import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import ModalWrapper from '../../../components/modalWrapper';

function ModalProcessXML({
  openModalProcessXML,
  setOpenModalProcessXML,
  processXML,
  numberOfClaims,
  totalAmount,
  showWarning = false,
}) {
  const { t } = useTranslation();
  const [warningAcknowledged, setWarningAcknowledged] = React.useState(false);

  function handleClose() {
    setOpenModalProcessXML(false);
    setWarningAcknowledged(false);
  }

  const showWarningMessage = showWarning && !warningAcknowledged;

  return (
    <ModalWrapper
      headerTitle={showWarningMessage ? t('achtung') : t('processXML')}
      openModal={openModalProcessXML}
      setModalWrapper={() => handleClose()}
    >
      <div
        className="modal_container__body__text"
        style={{
          maxWidth: '540px',
          margin: '0 0 5vh 0',
        }}
      >
        {showWarningMessage ? (
          <span>{t('xmlAlreadyGeneratedWarning')}</span>
        ) : (
          <>
            <span>
              {t('numberOfClaims')}: <span>{numberOfClaims}</span>
            </span>
            <br />
            <span>
              {t('totalAmount')}: <span>{totalAmount + ' €'}</span>
            </span>
          </>
        )}
      </div>
      <div className="modal_container__body__row-modal">
        <div
          className={`button_red_small ${isMobileOnly && 'mobile'}`}
          style={{ width: 'unset' }}
          onClick={() => {
            if (showWarningMessage) {
              setWarningAcknowledged(true);
            } else {
              processXML();
              handleClose();
            }
          }}
        >
          {showWarningMessage ? 'OK' : t('createXML')}
        </div>
      </div>
    </ModalWrapper>
  );
}

export default ModalProcessXML;
